import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=3b1ba850&scoped=true"
import script from "./Checkbox.vue?vue&type=script&lang=ts"
export * from "./Checkbox.vue?vue&type=script&lang=ts"
import style0 from "./Checkbox.vue?vue&type=style&index=0&id=3b1ba850&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1ba850",
  null
  
)

export default component.exports